const ADMIN_SUPPLIER_SEARCH_FIELDS = [
  'title',
  'secondTitle',
  'emailAddress',
  'accountNumber',
  'vendorCode',
]

const buildSupplierSearchHaystack = supplier =>
  ADMIN_SUPPLIER_SEARCH_FIELDS.map(field =>
    String(supplier?.[field] ?? '').trim(),
  )
    .filter(Boolean)
    .join(' ')
    .toLowerCase()

export const supplierMatchesSearchQuery = (supplier, searchTerm) => {
  const query = String(searchTerm ?? '')
    .trim()
    .toLowerCase()

  if (!query) {
    return true
  }

  const haystack = buildSupplierSearchHaystack(supplier)
  const tokens = query.split(/\s+/).filter(Boolean)

  return tokens.every(token => haystack.includes(token))
}

export const filterAdminSuppliersBySearch = (
  suppliers = [],
  searchTerm = '',
) => {
  const query = String(searchTerm ?? '').trim()

  if (!query) {
    return suppliers
  }

  return suppliers.filter(supplier =>
    supplierMatchesSearchQuery(supplier, query),
  )
}
